import React from 'react';
import classNames from 'classnames';
import { element } from 'prop-types';
export default class ModuleAccordionHeader extends React.Component {


  handleDelete  = e => {
    e.stopPropagation();
    this.props.handleDelete();
  };

  headerBtnClick = (e) => {
    if (e.target.classList.contains("quiz")) {
      setTimeout(this.bringQuizFocus, 700);
    }
  }

  bringQuizFocus = () => {
    console.log("quiz idx: ", this.props.moduleIdx);
    document
      .getElementsByClassName(`quizinfo-container ${this.props.moduleIdx + 1}`)[0]
      .scrollIntoView(false);
  };

  render(){
    return (
      <div className='accordion-head with-btn'>
         <span className="accordion-number">
           <i className={this.props.icon || ''}>
             {this.props.number || ''}
           </i>
         </span>
        <div className="accordion-caption">
          <span className="accordion-label">{this.props.label}</span>
          {/* {this.props.caption} */}
        </div>
        { this.props.btn &&
          <span
            className={classNames('accordion-btn btn bordered', {
              'prime': this.props.btn === 'view responses',
              'green empty': this.props.btn === 'completed',
              'blue empty': this.props.btn === 'progress',
              'blue empty quiz': this.props.btn === 'take quiz',
              'red empty': this.props.btn === 'incomplete',
            })}
            onClick={(e) => this.headerBtnClick(e)}
          >{this.props.btn}</span>
        }

        { this.props.canDelete &&
          <span className='accordion-btn btn bordered red empty' onClick={this.handleDelete}>Delete</span>
        }
      </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/create_workshop/create_module/ModuleAccordionHeader.jsx